import { render, staticRenderFns } from "./select-tour.vue?vue&type=template&id=2f8d37d0&"
import script from "./select-tour.vue?vue&type=script&lang=js&"
export * from "./select-tour.vue?vue&type=script&lang=js&"
import style0 from "./select-tour.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports